/**
 * Navbar Component
 *
 * Top navigation bar showing user info and logout button.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks';
import { Button } from './Button';
import { ThemeToggle } from './ThemeToggle';

export const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  const navbarStyles: React.CSSProperties = {
    backgroundColor: 'var(--bg-secondary)',
    borderBottom: '1px solid var(--border-color)',
    padding: '16px 32px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  };

  const leftStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };

  const rightStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };

  const userInfoStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  };

  const avatarStyles: React.CSSProperties = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
  };

  const nameStyles: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 500,
    color: 'var(--text-primary)',
  };

  const roleStyles: React.CSSProperties = {
    fontSize: '12px',
    color: 'var(--text-secondary)',
    textTransform: 'capitalize',
  };

  return (
    <nav style={navbarStyles}>
      <div style={leftStyles}>
        <img src="/logo-280x45.png"   alt="HitSearch" className="logo-light" style={{ height: '32px', width: 'auto', cursor: 'pointer' }} onClick={() => navigate('/services')} />
        <img src="/credits-logo2.png" alt="HitSearch" className="logo-dark"  style={{ height: '32px', width: 'auto', cursor: 'pointer' }} onClick={() => navigate('/services')} />
      </div>

      <div style={rightStyles}>
        <div style={userInfoStyles}>
          {user.photo && (
            <img
              src={user.photo}
              alt={user.name}
              style={avatarStyles}
            />
          )}
          <div>
            <div style={nameStyles}>{user.name}</div>
            <div style={roleStyles}>{user.role}</div>
          </div>
        </div>

        {user.role === 'admin' && (
          <Button variant="secondary" onClick={() => navigate('/admin/users')}>
            👥 Users
          </Button>
        )}

        <Button variant="secondary" onClick={() => navigate('/profile')}>
          ⚙️ Profile
        </Button>

        <ThemeToggle />

        <Button variant="secondary" onClick={handleLogout}>
          🚪 Logout
        </Button>
      </div>
    </nav>
  );
};
